<template>
  <div class="status-badge-container">
    <div v-if="badge.text" :class="`badge ${badge.badgeColor}`">
      <MdTypography
        :data-qa-id="`font-display-styles--badge-${badge.badgeColor}`"
        tag="div"
        :color="badge.textColor"
        variant="micro1--medium"
      >
        {{ badge.text }}
      </MdTypography>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { MdTypography } from '@antiqua-dls/vue-components'

const props = defineProps({
  params: {
    type: Object,
    required: true
  }
})

const { data } = props.params
const badge = computed(() => {
  const status = data['status'] || ''
  const statusLowerCase = status?.toLowerCase() || ''

  return {
    text: status,
    textColor: getStatusTextColor(statusLowerCase),
    badgeColor: statusLowerCase
  }
})

const getStatusTextColor = (status) => {
  switch (status) {
    case 'updated':
      return 'taco-yellow--700'
    case 'new':
      return 'blue-duck--700'
    case 'existing':
      return 'spirits--700'
    default:
      return 'spirits--700'
  }
}
</script>

<style lang="scss">
.status-badge-container {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;

  .badge {
    display: flex;
    padding: var(--md-spacing-unit--3xs) var(--md-spacing-unit--xs);
    align-items: center;
    gap: var(--md-spacing-unit--2xs);
    border-radius: var(--md-border-radius--sm);
  }

  .updated {
    background: var(--md-color--taco-yellow--100);
  }

  .new {
    background: var(--md-color--blue-duck--100);
  }

  .existing {
    background: var(--md-color--spirits--200);
  }
}
</style>
